/**
 * Economy plan preview page – Navbar + ArtistEconomyProfile + Footer.
 */

import React from "react";
import { Navbar } from "@/templates/Navbar";
import { Footer } from "@/templates/Footer";
import ArtistEconomyProfile from "./Economy/ArtistEconomyProfile";

export interface EconomyPreviewProps {
  isMobile?: boolean;
}

export default function EconomyPreview({ isMobile = false }: EconomyPreviewProps) {
  return (
    <div className="text-white">
      {/* <Navbar /> */}
      <ArtistEconomyProfile isMobile={isMobile} />
      <Footer />
    </div>
  );
}
